/**
 * Top-level validation engine. This is the ONE function that should be
 * called both after auto-generation and after every manual edit (PRD §8,
 * §16.2 — "validation is a separate, reusable function from generation...
 * must not be duplicated as two separate implementations").
 *
 * Pure function: (objects, context) -> issues[]. No I/O, no framework
 * dependency.
 */

import type { LayoutObject, ValidationContext, ValidationIssue } from '../types';
import {
  checkTableToTableClearance,
  checkDanceFloorBuffer,
  checkDjBoothBuffer,
  checkFeatureZoneCrowding,
} from './rules/spacing';
import { checkInventoryLimits, checkSeatCountMismatch } from './rules/inventory';
import { checkRoomBoundary } from './rules/boundary';
import { checkLongTableFloorLength } from './rules/longTableFit';

export function validateLayout(
  objects: LayoutObject[],
  context: ValidationContext
): ValidationIssue[] {
  const { roomDefinition, objectCatalog, inventoryLimits, guestCount, layoutStyle } = context;

  return [
    ...checkTableToTableClearance(objects, objectCatalog),
    ...checkDanceFloorBuffer(objects, objectCatalog),
    ...checkDjBoothBuffer(objects, objectCatalog),
    ...checkFeatureZoneCrowding(objects, objectCatalog),
    ...checkInventoryLimits(objects, inventoryLimits),
    ...checkSeatCountMismatch(objects, guestCount),
    ...checkRoomBoundary(objects, roomDefinition, objectCatalog),
    ...checkLongTableFloorLength(objects, roomDefinition, layoutStyle),
  ];
}
